export default "__VITE_ASSET__1cbccdb0__"